<div class="dvb-kita-chart-personal">
    <canvas id="kita-chart-personal" ng-mouseleave="vm.onMouseLeave()"></canvas>
</div>
